<template>
  <section class="evento-lux">
    <article ref="card1" class="card" aria-label="Celebración">
      <img class="icono" src="@/assets/Copia de Copia de Diseño sin título (13).png" alt="" />
      <h3 class="titulo-script">Celebración</h3>
      <p class="hora">6:30 PM</p>
      <p class="lugar">
        Chic Venue In Tampa 
      </p>
      <div ref="fotoWrapper" class="foto-container-wrapper">
        <div class="foto-circular-box">
          <img class="foto-principal" src="@/assets/ChatGPT Image 31 may 2026, 10_27_56 p.m..png" alt="Lugar del evento" />
        </div>
        <img class="liston-decorativo" src="@/assets/liston.png" alt="" />
      </div>
      <p class="direccion">
       9210 Anderson Rd <br>
       Tampa, Florida.
      </p>

      
     
      <a
        ref="btn1"
        class="btn-rosa"
        href="https://maps.app.goo.gl/gEhw2jJKaj3Q7qb48"
        target="_blank"
        rel="noopener"
      >
        ¿Cómo llegar?
        <span class="sheen"></span>
      </a>
    </article>
    
    <br><br>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {
    const card1 = ref(null)
    const btn1 = ref(null)
    const fotoWrapper = ref(null)

    const animCard = (cardEl, btnEl, fotoEl) => {
      const $ = gsap.utils.selector(cardEl)
      const icono  = $('.icono')
      const titulo = $('.titulo-script')
      const hora   = $('.hora')
      const lugar  = $('.lugar')
      const dir    = $('.direccion')
      const nota   = $('.ceremonia-nota')
      
      // Selectores para la foto y el listón dentro del wrapper
      const fotoCirculo = fotoEl.querySelector('.foto-circular-box')
      const liston = fotoEl.querySelector('.liston-decorativo')

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 85%',
          toggleActions: 'play none none none'
        },
        defaults: { ease: 'power2.out' }
      })

      tl.from(cardEl, {
        opacity: 0,
        y: 40,
        duration: 0.6
      })
      .from(icono, {
        opacity: 0,
        y: 20,
        scale: 0.7,
        rotation: -12,
        duration: 0.6,
        ease: 'back.out(1.7)'
      }, '-=0.3')
      .from(titulo, {
        opacity: 0,
        y: 20,
        duration: 0.5
      }, '-=0.3')
      .from(hora, {
        opacity: 0,
        x: -20,
        duration: 0.4
      }, '-=0.3')
      .from(lugar, {
        opacity: 0,
        x: 20,
        duration: 0.4
      }, '-=0.4')
      .from(dir, {
        opacity: 0,
        y: 20,
        duration: 0.4
      }, '-=0.3')
      
      /* ANIMACIÓN DE LA FOTO Y EL LISTÓN */
      .from(fotoCirculo, {
        opacity: 0,
        scale: 0.8,
        y: 25,
        duration: 0.6,
        ease: 'back.out(1.2)'
      }, '-=0.2')
      .from(liston, {
        opacity: 0,
        x: 30,
        y: -30,
        rotation: 15,
        duration: 0.6,
        ease: 'back.out(1.5)'
      }, '-=0.3')

      /* 🔥 NOTA BONITA */
      .from(nota, {
        opacity: 0,
        y: 25,
        scale: 0.9,
        duration: 0.7,
        ease: 'back.out(1.7)'
      }, '-=0.2')
      .from(btnEl, {
        opacity: 0,
        scale: 0.95,
        duration: 0.4
      }, '-=0.3')

      // brillo botón
      ScrollTrigger.create({
        trigger: cardEl,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const shine = btnEl.querySelector('.sheen')
          if (!shine) return
          gsap.fromTo(
            shine,
            {
              xPercent: -120,
              opacity: 0
            },
            {
              xPercent: 140,
              opacity: 1,
              duration: 0.8,
              ease: 'power2.out'
            }
          )
          /* 🔥 LATIDO NOTA */
          gsap.to(nota, {
            scale: 1.02,
            duration: 2,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut'
          })
        }
      })
    }

    onMounted(() => {
      animCard(card1.value, btn1.value, fotoWrapper.value)
    })

    return {
      card1,
      btn1,
      fotoWrapper
    }
  }
}
</script>

<style scoped>
/* ==================== ssssssssBASE ELEGANTE ==================== */
:root{
  --rosa: #f4c6cc;
  --rosa-alt: #f0c3e3;
  --tinta: #141414;
  --gris: #5a5858;
  --borde: #e8e4e4;
}
.evento-lux{
  min-height: 100%;
  padding: 28px 18px 4px;
  background:
    radial-gradient(
      1200px 600px at 50% -10%,
      rgba(255,255,255,.92),
      rgba(255,255,255,.98)
    ),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6"><rect width="6" height="6" fill="white"/><circle cx="3" cy="3" r="0.6" fill="%23f1f1f1"/></svg>') repeat;
  display: grid;
  gap: 22px;
  place-items: center;
}
/* ==================== TARJETA ==================== */
.card{
  width: min(440px, 92vw);
  border: 1px solid var(--borde);
  border-radius: 18px;
  padding: 24px 20px 28px;
  text-align: center;
}
/* Icono discreto */
.icono{
  width: 192px;
  height:auto;
  display:block; 
  margin-bottom: -60px !important;
  margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0,0,0,.05));
  opacity: .92;
}
/* Tipos */
.titulo-script{
  font-family: 'britishgruesa', cursive;
  font-weight: 400;
  font-size: 56px;
  color: var(--tinta);
  letter-spacing: .4px;
  margin: 4px 0 8px;
}
.hora{
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: var(--tinta);
  margin: 0 0 6px;
}
.lugar{
  font-family: 'padres', serif;
  font-size: 22px;
  color: #000;
  font-weight: 500;
  margin: 0 0 10px;
  letter-spacing: .14em;
}
.direccion{
  font-family: 'padres', serif;
  font-style: italic;
  color: var(--gris);
  font-size: 17px !important;
  line-height: 1.5;
  margin: 0 auto 16px;
  max-width: 90%;
}

/* ==================== SECCIÓN DE FOTO Y LISTÓN ==================== */
.foto-container-wrapper {
  position: relative;
  width: 180px;
  height: 180px;
  margin: 0 auto 24px;
}
.foto-circular-box {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #fff;
  box-shadow: 0 8px 20px rgba(0,0,0,.12);
}
.foto-principal {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.liston-decorativo {
  position: absolute;
  top: 2px;
  opacity: 0 !important;
  right: 122px !important;
  width: 225px !important;
  height: auto;
  z-index: 2;
  filter: drop-shadow(2px 4px 6px rgba(0,0,0,0.15));
}

/* 🔥 NOTA */
.ceremonia-nota{
  font-family:'padres', serif;
  font-size:17px;
  line-height:1.7;
  color:#383636;
  max-width:88%;
  margin:14px auto 18px;
  font-style:italic;
  letter-spacing:.03em;
  padding:12px 16px;
  border-radius:16px;
  background:
    linear-gradient(
      135deg,
      rgba(150, 75, 125, 0.18),
      rgba(224, 133, 183, 0.75)
    );
  border:1px solid rgba(245,201,230,.5);
  box-shadow:
    0 6px 16px rgba(0,0,0,.05);
}
/* ==================== BOTÓN ROSA ==================== */
.btn-rosa{
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 20px;
  border-radius: 14px;
  background: #f5c9e6;
  color: #1f1f1f;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 14px;
  line-height: 1;
  box-shadow:
    0 8px 16px rgba(0,0,0,.12),
    inset 0 1px 0 rgba(255,255,255,.7);
  transition:
    transform .16s ease,
    box-shadow .16s ease,
    filter .16s ease;
  border: 1px solid rgba(0,0,0,.06);
  z-index: 0;
}
.btn-rosa:hover{
  transform: translateY(-1px);
  box-shadow:
    0 12px 20px rgba(0,0,0,.16),
    inset 0 1px 0 rgba(255,255,255,.8);
  filter: brightness(1.03);
}
.btn-rosa .sheen{
  position: absolute;
  top: -30%;
  left: -30%;
  width: 60%;
  height: 160%;
  transform: rotate(20deg);
  background:
    linear-gradient(
      90deg,
      rgba(255,255,255,0) 0%,
      rgba(255,255,255,.55) 50%,
      rgba(255,255,255,0) 100%
    );
  pointer-events: none;
  mix-blend-mode: screen;
  opacity: 0;
}
/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px){
  .titulo-script{
    font-size: 32px;
  }
  .hora{
    font-size: 22px;
  }
  .lugar{
    font-size: 16px;
  }
}
/* Accesibilidad */
@media (prefers-reduced-motion: reduce){
  *{
    transition: none !important;
    animation: none !important;
  }
}
</style>